<div class="visitor-counter-container inline-block font-sans">
  <div class="flex items-center bg-gradient-to-r from-blue-600 to-indigo-700 text-white rounded-lg px-3 py-2 text-sm shadow-md group relative">
    <i class="bx bx-user text-lg mr-2"></i>
    <div class="flex flex-col">
      <div class="text-xs font-medium tracking-wide" [class.animate-pulse]="isAnimating">{{ visitorCount | number }} Visits</div>
    </div>
    
    <!-- Tooltip -->
    <div class="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity duration-300 w-40 p-2 bg-gray-800 text-white text-xs rounded shadow-lg z-10">
      Last updated: {{ lastUpdate }}
      <div class="absolute top-full left-1/2 transform -translate-x-1/2 w-3 h-3 bg-gray-800 rotate-45"></div>
    </div>
  </div>
</div>